(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/widget/assets/javascripts/track-click.js') >= 0) return;  svs.modules.push('/components/content/widget/assets/javascripts/track-click.js');

'use strict';

(function () {
  var trackClick = function trackClick(event) {
    var element = event.currentTarget;
    var clickTrackingString = element.dataset.clickTracking;

    var getWidgetPosition = function getWidgetPosition() {
      var widgetStdClass = 'widget';
      var allWidgetsInDom = document.getElementsByClassName(widgetStdClass);
      var thisWIdgetElement = element.closest('div.widget');
      return Array.prototype.indexOf.call(allWidgetsInDom, thisWIdgetElement) + 1;
    };
    if (clickTrackingString) {
      var evt = {
        name: clickTrackingString,
        position: getWidgetPosition()
      };
      if (element.getAttribute('target') && element.getAttribute('target') !== '_self') {
        svs.components.analytics.trackPromoClick(evt);
        return true;
      }
      event.preventDefault();
      svs.components.analytics.trackPromoClick(evt, function () {
        document.location = element.getAttribute('href');
      });
      return false;
    }
  };
  $('body').on('click', '*[data-click-tracking]', trackClick);
})();

 })(window);